import { defineComponent as V, openBlock as o, createElementBlock as e, mergeProps as i, unref as n, renderSlot as u, createElementVNode as l, createCommentVNode as v } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, A = { key: 1 }, m = { key: 2 }, M = { key: 3 }, g = { key: 4 }, h = { key: 5 }, f = {
  name: "ScalarIconPictureInPicture"
}, y = /* @__PURE__ */ V({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: a } = p(r);
    return (d, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(s)), [
      u(d.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        l("path", { d: "M216,44H40A20,20,0,0,0,20,64V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V64A20,20,0,0,0,216,44ZM44,68H212v48H136a12,12,0,0,0-12,12v60H44ZM148,188V140h64v48Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M224,64v64H136v72H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H216A8,8,0,0,1,224,64Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,64H216v56H136a8,8,0,0,0-8,8v64H40ZM216,192H144V136h72v56Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", m, t[2] || (t[2] = [
        l("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48Zm0,144H136V128h80v64Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", M, t[3] || (t[3] = [
        l("path", { d: "M216,50H40A14,14,0,0,0,26,64V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V64A14,14,0,0,0,216,50ZM38,192V64a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2v58H136a6,6,0,0,0-6,6v66H40A2,2,0,0,1,38,192Zm178,2H142V134h76v58A2,2,0,0,1,216,194Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", g, t[4] || (t[4] = [
        l("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,64H216v56H136a8,8,0,0,0-8,8v64H40ZM216,192H144V136h72v56Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        l("path", { d: "M216,52H40A12,12,0,0,0,28,64V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V64A12,12,0,0,0,216,52ZM36,192V64a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4v60H136a4,4,0,0,0-4,4v68H40A4,4,0,0,1,36,192Zm180,4H140V132h80v60A4,4,0,0,1,216,196Z" }, null, -1)
      ]))) : v("", !0)
    ], 16));
  }
});
export {
  y as default
};
